export function obterListaCTeServicoCST() {
  return (
    [
      { label: '00 - Tributação Normal', value: 'TRIBUTADO' },
      { label: '20 - Tributação com Base Redução', value: 'BASEREDUCAO' },
      { label: '40 - Isenção', value: 'ISENCAO' },
      { label: '41 - Não Tributado', value: 'NAOTRIBUTADO' },
      { label: '51 - Diferido', value: 'DIFERIDO' },
      { label: '60 - ICMS Cobrado anteriormente por ST', value: 'ICMSST' },
      { label: '90 - Outros', value: 'OUTROS' },
    ]
  );
}
